import { Colors, Text } from '@mercator-gcp/grout';
import LatestActivityTable from 'pages/ProjectDetails/LatestActivityTable';
import { Project } from 'types';
import { ProjectActivitySummary } from 'types/ActivitySummary';

type Props = {
  projectSlug?: Project['slug'];
  projectActivitySummary: ProjectActivitySummary | null;
  isLoading: boolean;
  isError: boolean;
  showCompanyContacts?: boolean;
};

const SummaryView = ({
  projectSlug,
  projectActivitySummary,
  isLoading,
  isError,
  showCompanyContacts,
}: Props) => {
  if (isError) {
    return (
      <Text color={Colors.SystemColorNegative}>
        Something went wrong while loading stages. Please refresh to try again.
      </Text>
    );
  }

  if (isLoading || !projectActivitySummary) {
    return null;
  }

  return (
    <LatestActivityTable
      projectSlug={projectSlug}
      summarizedActivityList={projectActivitySummary.summarized_activities}
      showCompanyContacts={showCompanyContacts}
    />
  );
};

export default SummaryView;
